import React from 'react';
import RawGravatar from 'react-gravatar';

// Always use https:// — react-gravatar's default protocol is `//`, which
// resolves to http:// on the dev server and trips the CSP img-src directive.
type Props = {
  email: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
};

const Gravatar: React.FunctionComponent<Props> = (props) => (
  // react-gravatar ships no .d.ts; cast through unknown so the wrapper
  // exposes a clean typed surface without spreading the suppression.
  React.createElement(RawGravatar as unknown as React.ComponentType<Props & {protocol: string}>, {
    ...props,
    protocol: 'https://',
  })
);

export default Gravatar;
